






































































import { Getter } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import FolderNode from "@/components/common/folders/FolderNode.vue";
import { Folder, FolderEntites } from "@/services/folders/types";
import { getFolderStructure } from "@/services/folders/folderService";
import FolderDeleteModal from "@/components/common/folders/FolderDeleteModal.vue";
import { PermitionEnum, HavePermition } from "@/components/security/Permitions";

@Component({
    components: {
        "folder-node": FolderNode,
        "folder-delete-modal": FolderDeleteModal
    }
})
export default class FolderTree extends Vue {
    @Prop() private folderEntity!: FolderEntites;
    @Prop() private showActionButtons!: boolean;
    @Prop({ default: "" }) private instance!: string;
    @Prop({ default: true }) private showHeader!: boolean;
    @Prop({ default: "" }) folderId!: string;
    @Prop({ default: false }) isSystemFiles!: boolean;
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;

    // local state
    model = {} as Folder;
    selectedFolderNode = {} as Folder;
    movedFolder = {} as Folder;
    movedFolderId = "" as string;
    targetFolderId = "" as string;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    isDraggingFolder = false;
    bus = new Vue();

    // computed properties
    get folderNodeIsSelected(): boolean {
        return Object.keys(this.selectedFolderNode).length > 0;
    }

    get rootNodeIsSelected(): boolean {
        return this.folderNodeIsSelected && this.selectedFolderNode.parentFolderId == null;
    }

    get defaultFolderId() : string | null {
        // Initialize the resolvedFolderId as an null
        let resolvedFolderId : string | null = null;

        // Check if folderId prop is not an empty string and use it if available
        if (this.folderId !== "") {
            resolvedFolderId = this.folderId;
        } else {
            // Check if $route.query.folder is a non-empty string and use it if available
            if (typeof this.$route.query.folder === "string" && this.$route.query.folder !== "") {
                resolvedFolderId = this.$route.query.folder.toLowerCase();
            }
        }

        // Check if the model is not an empty object
        const isModelEmpty: boolean = Object.keys(this.model).length === 0;

        // If the model is not empty, check if the folder exists in the tree
        const folderExists: boolean = !isModelEmpty && this.containsElement(this.model, resolvedFolderId);

        // Set the defaultFolderId
        return folderExists ? resolvedFolderId : null;
    }

    // methods
    addFolderNode() {
        if (!this.selectedFolderNode.children) { Vue.set(this.selectedFolderNode, "children", []); }

        if (this.selectedFolderNode.children) {
            this.selectedFolderNode.children.push({
                id: "",
                name: "",
                isOpen: false,
                editMode: true,
                activateDelete: false,
                parentFolderId: this.selectedFolderNode.id,
                claim: "InheretedAccess"
            } as Folder);
        }

        Vue.set(this.selectedFolderNode, "isOpen", true);
    }

    renameFolderNode() {
        Vue.set(this.selectedFolderNode, "editMode", true);
    }

    deleteFolderNode() {
        (this.$refs.folderDeleteModal as any).open(this.selectedFolderNode.id, this.selectedFolderNode.name, this.isSystemFiles);
    }

    confirmDelete() {
        Vue.set(this.selectedFolderNode, "activateDelete", true);
        this.selectedFolderNode = {} as Folder;
    }

    removeMovedFolder(currentFolder: Folder) {
        if (currentFolder.children) {
            for (let i = 0; i < currentFolder.children.length; i++) {
                if (currentFolder.children[i].id === this.movedFolderId) {
                    this.movedFolder = JSON.parse(JSON.stringify(currentFolder.children[i]));
                    currentFolder.children.splice(i, 1);
                    return;
                } else this.removeMovedFolder(currentFolder.children[i]);
            }
        }
    }

    placeMovedFolder(currentFolder: Folder) {
        if (currentFolder.id === this.targetFolderId) {
            if (!currentFolder.children) { Vue.set(currentFolder, "children", []); }
            if (currentFolder.children) {
                currentFolder.children.push(this.movedFolder as Folder);
                Vue.set(currentFolder, "isOpen", true);
                this.selectFolder(this.movedFolder);
            }
        } else if (currentFolder.children) {
            currentFolder.children.forEach((child) => {
                this.placeMovedFolder(child);
            });
        }
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
        this.$emit("select-folder", folder);
    }

    clearSelection(currentFolder: Folder) {
        Vue.set(currentFolder, "isSelected", false);
        if (currentFolder.children) {
            currentFolder.children.forEach((child) => {
                this.clearSelection(child);
            });
        }
    }

    toggleFolderTree() {
        this.$emit("toggle-folder-tree");
    }

    created() {
        getFolderStructure(this.folderEntity).then(
            response => {
                this.model = response;
            }
        );

        this.bus.$on("entity-moved-event-finished", (data: { entityId: string, folderId: string }) => {
            this.$emit("entity-moved-event-finished", data);
        });

        this.bus.$on("drag-folder-start", () => {
            this.isDraggingFolder = true;
        });
        this.bus.$on("drag-folder-stop", () => {
            this.isDraggingFolder = false;
        });
        this.bus.$on("folder-moved", (data: {folderId: string, targetFolderId: string}) => {
            this.movedFolderId = data.folderId;
            this.targetFolderId = data.targetFolderId;
            this.selectedFolderNode = {} as Folder;
            this.removeMovedFolder(this.model);
            this.placeMovedFolder(this.model);
        });
    }

    restrictActionButtons() {
        return this.selectedFolderNode.claim === "InheretedAccess" || this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.AdminPrivilege]);
    }

    containsElement(element: any, id: any): boolean {
        if (element.id === id) {
            return true;
        } else if (element.children != null) {
            for (let i = 0; i < element.children.length; i++) {
                if (this.containsElement(element.children[i], id)) {
                    return true;
                }
            }
        }
        return false;
    }
}
